import React from 'react';

export const Home: React.FC = () => {
  return (
    <div>
      {/* Hero Section */}
<section className="bg-gradient-to-br from-blue-600 to-blue-800 text-white py-20">
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
    <h1 className="text-5xl font-bold mb-6">
      CoKilo - Partage de Bagages
    </h1>
    <p className="text-xl mb-8 text-blue-100">
      Connectez voyageurs et expéditeurs pour un transport de colis économique et sécurisé
    </p>
    <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
      
      <a href="#" className="inline-block">
        <img 
          src="https://play.google.com/intl/en_us/badges/static/images/badges/fr_badge_web_generic.png" 
          alt="Disponible sur Google Play" 
          className="h-[64px]"
        />
      </a>
      <a href="#" className="inline-block">
        <img 
          src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/fr-fr?size=250x83&releaseDate=1705363200" 
          alt="Télécharger sur l'App Store" 
          className="h-12"
        />
      </a>
    </div>
  </div>
</section>

      {/* Coming Soon Banner */}
      <section className="bg-yellow-50 border-y border-yellow-200 py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-2xl font-bold text-yellow-800">
            🚀 Lancement Imminent - Inscrivez-vous pour être notifié !
          </p>
        </div>
      </section>

      {/* Features */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center mb-12">
            Comment ça marche ?
          </h2>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center p-6 bg-white rounded-lg shadow-md">
              <div className="text-5xl mb-4">✈️</div>
              <h3 className="text-xl font-semibold mb-3">Pour les Voyageurs</h3>
              <p className="text-gray-600">
                Monétisez l'espace disponible dans vos bagages en transportant des colis
              </p>
            </div>

            <div className="text-center p-6 bg-white rounded-lg shadow-md">
              <div className="text-5xl mb-4">📦</div>
              <h3 className="text-xl font-semibold mb-3">Pour les Expéditeurs</h3>
              <p className="text-gray-600">
                Envoyez vos colis moins cher et plus rapidement qu'avec les transporteurs traditionnels
              </p>
            </div>

            <div className="text-center p-6 bg-white rounded-lg shadow-md">
              <div className="text-5xl mb-4">🔒</div>
              <h3 className="text-xl font-semibold mb-3">100% Sécurisé</h3>
              <p className="text-gray-600">
                Paiements sécurisés, vérification d'identité et système d'évaluation
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-gray-100 py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold mb-6">
            Prêt à rejoindre CoKilo ?
          </h2>
          <p className="text-xl text-gray-600 mb-8">
            Téléchargez l'application dès qu'elle sera disponible
          </p>
          <button className="bg-blue-600 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-blue-700">
            M'avertir du lancement
          </button>
        </div>
      </section>
    </div>
  );
};